import IconShare from '@dealroadshow/uikit-icon/IconShare';
import IconUpload from '@dealroadshow/uikit-icon/IconUpload';
import IconUserStar from '@dealroadshow/uikit-icon/IconUserStar';
import { IconComponentType } from '@dealroadshow/uikit-icon';

interface ISupportItem {
  icon: IconComponentType,
  key: string,
  title: string,
  description: string,
}

export const supports: ISupportItem[] = [
  {
    icon: IconShare,
    key: 'share',
    title: 'Securely share your allocations in any format',
    description: 'We accept any file type via email or secure file sharing platforms. We can also provide a data room for a secure file transfer.',
  },
  {
    icon: IconUpload,
    key: 'upload',
    title: 'Allocations are then uploaded by our fanatical 24x7 support team',
    description: 'FINSIGHT will promptly upload and integrate your historical allocations data with our proprietary new issue pricing data and investor profiles.',
  },
  {
    icon: IconUserStar,
    key: 'tour',
    title: 'We conduct a guided tour of Allocate to ensure success',
    description: 'Once your allocations have been uploaded, a member of our Allocate team will connect with you for a walkthrough to ensure a successful implementation.',
  },
];
